import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';

export default function TargetMessagingComposerNote({ note }: { note: string }) {
  const theme = useTheme();

  return (
    <Typography
      data-test-id="target-messaging-composer-note"
      sx={{ color: theme.semantic.textSecondary, px: 0.5 }}
      variant="caption"
    >
      {note}
    </Typography>
  );
}
